import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ProblemSolution, RequestHistory, UserSupport } from './index';

export default /*#__PURE__*/_defineComponent({
  __name: 'Support',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ProblemSolution), { class: "mb--30" }),
    _createVNode(_unref(UserSupport), { class: "mb--30" }),
    _createVNode(_unref(RequestHistory))
  ], 64))
}
}

})